const API_URL = import.meta.env.VITE_API_URL || 'https://verbum-api-production.up.railway.app/api';

class TaskService {
  async fetchWithAuth(url, options = {}) {
    const authToken = localStorage.getItem('authToken');
    console.log('🔍 fetchWithAuth - AuthToken from localStorage:', authToken ? 'EXISTS' : 'NOT FOUND');
    console.log('🔍 fetchWithAuth - URL:', url);
    
    if (!authToken) {
      throw new Error('No authentication token found. Please login again.');
    }
    
    const headers = {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${authToken}`,
      ...options.headers,
    };
    
    console.log('🔍 fetchWithAuth - Headers:', headers);

    const response = await fetch(url, {
      ...options,
      headers,
    });

    if (!response.ok) {
      if (response.status === 401) {
        // Clear invalid token and redirect to login
        localStorage.removeItem('authToken');
        window.location.href = '/';
        throw new Error('Authentication failed. Please login again.');
      }
      throw new Error(`HTTP ${response.status}: ${response.statusText}`);
    }

    return response.json();
  }

  async getTasks(view = 'today') {
    return this.fetchWithAuth(`${API_URL}/tasks?view=${view}`);
  }

  async getTaskById(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}`);
  }


  async getTaskView(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}`);
  }

  async createTaskPreview(text) {
    return this.fetchWithAuth(`${API_URL}/tasks/preview`, {
      method: 'POST',
      body: JSON.stringify({ text }),
    });
  }

  async createTask(previewData) {
    return this.fetchWithAuth(`${API_URL}/tasks`, {
      method: 'POST',
      body: JSON.stringify(previewData),
    });
  }

  async completeTask(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}/status/done`, {
      method: 'PATCH',
    });
  }


  async updateTaskFull(taskId, taskData) {
    console.log('🔧 updateTaskFull called with:', { taskId, taskData });
    console.log('🔧 updateTaskFull URL:', `${API_URL}/tasks/${taskId}`);
    console.log('🔧 updateTaskFull body:', JSON.stringify(taskData, null, 2));
    
    try {
      const result = await this.fetchWithAuth(`${API_URL}/tasks/${taskId}`, {
        method: 'PUT',
        body: JSON.stringify(taskData),
      });
      console.log('🔧 updateTaskFull success:', result);
      return result;
    } catch (error) {
      console.error('🔧 updateTaskFull error:', error);
      console.error('🔧 updateTaskFull error details:', {
        message: error.message,
        stack: error.stack,
        name: error.name
      });
      throw error;
    }
  }

  async deleteTask(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}`, {
      method: 'DELETE',
    });
  }

  async reopenTask(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}/status/todo`, {
      method: 'PATCH',
    });
  }

  async transcribeAudio(audioBlob) {
    const formData = new FormData();
    formData.append('audio', audioBlob, 'voice.ogg');

    const authToken = localStorage.getItem('authToken');
    const response = await fetch(`${API_URL}/audio`, {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${authToken}`,
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }

    return response.json();
  }

  async getTodayTasks() {
    return this.fetchWithAuth(`${API_URL}/tasks?view=today`);
  }

  async getAllTasks() {
    return this.fetchWithAuth(`${API_URL}/tasks?view=all`);
  }

  async getInboxTasks() {
    return this.fetchWithAuth(`${API_URL}/tasks?view=inbox`);
  }

  async getPendingTask(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}`);
  }

  async confirmPendingTask(taskId) {
    console.log('🔧 confirmPendingTask called with taskId:', taskId);
    console.log('🔧 confirmPendingTask URL:', `${API_URL}/tasks/${taskId}`);
    // Use PUT to update task (automatically confirms pending tasks)
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}`, {
      method: 'PUT',
      body: JSON.stringify({ status: 'todo' }),
    });
  }

  async getTemplates() {
    return this.fetchWithAuth(`${API_URL}/tasks/templates`);
  }

  async resetTemplate(taskId) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}/reset`, {
      method: 'POST',
    });
  }

  async editTaskWithAI(taskId, task, editText) {
    return this.fetchWithAuth(`${API_URL}/tasks/${taskId}/edit`, {
      method: 'POST',
      body: JSON.stringify({ 
        task: task,
        editText: editText 
      }),
    });
  }
}

export const taskService = new TaskService();

